import { IconRefresh } from '@tabler/icons-react'

import { Button } from '@/components/sui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/sui/tooltip'
import { useComponentTranslation } from '@/hooks/use-component-translation'

import locales from './locales'

interface ReactivateBannerProps {
  collapsed?: boolean
  onCtaClick: () => void
}

export function ReactivateBanner({
  collapsed = false,
  onCtaClick,
}: ReactivateBannerProps) {
  const { t } = useComponentTranslation(locales)

  if (collapsed) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            render={
              <Button
                size="icon"
                aria-label={t('collapsedTooltip')}
                className="h-12 w-full bg-gradient-to-br from-indigo-500 to-blue-600 text-white hover:opacity-90 focus-visible:border-indigo-500 focus-visible:ring-indigo-500/50"
                onClick={onCtaClick}
              />
            }
          >
            <IconRefresh className="h-5 w-5" />
          </TooltipTrigger>
          <TooltipContent side="right">
            <p>{t('collapsedTooltip')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return (
    <div className="flex flex-col gap-3 rounded-lg bg-gradient-to-br from-indigo-500 to-blue-600 p-3 text-white">
      <div className="flex items-start gap-2">
        <div className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-white/15">
          <IconRefresh className="size-3" />
        </div>
        <span className="text-sm font-semibold">{t('title')}</span>
      </div>

      <p className="text-xs leading-snug opacity-80">{t('description')}</p>

      <Button
        size="sm"
        onClick={onCtaClick}
        className="mt-1 w-full bg-white text-indigo-700 hover:bg-white/90 focus-visible:border-white focus-visible:ring-white/50"
      >
        {t('cta')}
      </Button>
    </div>
  )
}
